
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import InfoIcon from '../../../core/components/Generics/InfoIcon.vue';
import WarningMapOverwrite from './WarningMapOverwrite.vue';

@Component({
  components: {
    InfoIcon,
    WarningMapOverwrite,
  },
})
export default class OverwriteGeneralMapOption extends Vue {
  @Prop({ default: false }) value!: boolean;
  tooltipWarning: string = "Si esta opción esta activada, se eliminarán los polígonos existentes en el Mapa principal y se mantendrán solo los seleccionados. <br> De lo contrario, los polígonos seleccionados se sumarán a los ya existentes en el Mapa principal";


  @Emit('input')
  onChange(checked: boolean) {
    return checked;
  }
}
